import { StoreConfigurationService } from './../../graphQL/services/store-configurations/store-configurations.service';
import { NgModule , CUSTOM_ELEMENTS_SCHEMA, importProvidersFrom } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS, RECAPTCHA_LOADER_OPTIONS } from 'ng-recaptcha';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { BaseTranslateService } from '../../commons/services/base-translate.service';
import { AuthService } from './services/auth.service';
import { BaseHandleErrorService } from '../../commons/services/base-handle-error.service';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { CustomTranslateService } from '../../commons/services/custom-translate.service';
import { ProgreesBarService } from '../../commons/services/progrees-bar.service';
import {AuthRoutes}from  './auth.routing'
import { AppProgressBarComponent } from '../../commons/components/app-progress-bar/app-progress-bar.component';
import { LoginComponent } from './components/login/login.component';
import { ProgressBar } from 'primeng/progressbar';
import { ProgressBarModule } from 'primeng/progressbar';

import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { RegisterComponent } from './components/register/register.component';
import { TooltipModule } from 'primeng/tooltip';
import { RegisterUserForm } from '../../commons/form-validators/forms/user/registerUser.form';
import { FormValidatorService } from '../../commons/form-validators/validators/form-validator.service';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { UserGraphQLService } from '../../graphQL/services/user/userGraphQL.service';
import { BaseGraphqlService } from '../../graphQL/services/graphQL.service';
import { graphqlProvider } from '../../graphQL/graphql.provider';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { AppModalComponent } from '../../commons/components/app-modal/app-modal.component';
import { ModalService } from '../../commons/services/modal.service';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownModule } from 'primeng/dropdown';
@NgModule({
  imports: [
    AuthRoutes,

    CommonModule,
    ButtonModule,
    ProgressBarModule,
    RecaptchaModule,
    CalendarModule,
    CheckboxModule,
    DividerModule,
    RecaptchaFormsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    TooltipModule,
    InputNumberModule,
    DialogModule,    
    SkeletonModule,
    DropdownModule,
    TranslateModule
  ],
  exports: [
    TranslateModule  // Exportar para que esté disponible en los componentes
  ],
  declarations: [AppProgressBarComponent,LoginComponent, RegisterComponent,PasswordRecoveryComponent,AppModalComponent,CreateAccountComponent
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey,
      } as RecaptchaSettings,
    }, {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useValue: "es",
    },
    [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey }],

    TranslateStore,
    TranslateService,
    AuthService,
    ProgressBar,
    BaseHandleErrorService,
    BaseTranslateService,
    CustomTranslateService,
    ProgreesBarService,
    CalendarModule,
    CheckboxModule,
    RegisterUserForm,
    FormValidatorService,
    UserGraphQLService,
    BaseGraphqlService,
    StoreConfigurationService,

    ModalService,
    importProvidersFrom([
      JwtModule.forRoot({
        config: {
          tokenGetter: () => localStorage.getItem('idToken')
        }
      })
    ])
  ]
})
export class AuthModule { }
